import styled from 'styled-components';

// matches styling of ui library non iframe equivalent

export const Container = styled.div`
    position: relative;
    display: block;
    min-height: 72px;
    width: 100%;
`;

export const Label = styled.span`
    position: absolute;
    top: ${({ active }) => (active ? '0px' : '18px')};
    left: 0;
    user-select: none;
    color: ${({ hasError, theme }) => (hasError ? '#f44336' : theme.colors['Level 4'])};
    height: 12px;
    white-space: nowrap;
    transition: all 0.2s;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    pointer-events: none;
    ${({ theme }) => theme.typography.SmallCapsHeadline};
`;

export const InputWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 49px;
    border-bottom: 2px solid
        ${({ hasError, theme }) => (hasError ? '#f44336' : theme.colors['Level 4'])};
`;

export const ErrorContainer = styled.span`
    display: block;
    margin-bottom: 4px;
    padding-top: 50px;
    line-height: 1.35;
    color: #f44336;
    font-style: italic;
    font-weight: bold;
    font-size: 0.8em;
    letter-spacing: 0.02em;
`;
